"use strict";
/**
 * Moderation `users` canonical template — single source of truth for the
 * `moderation-users` OpenSearch index family (registered by the setup lambda).
 *
 * Moderation families are REGISTRAR-ONLY (setup lambda registers; the search endpoint
 * reads by alias), have NO search-document interface, and are NOT read by application
 * search queries — so they expose a TEMPLATE BUILDER ONLY (no `*_FIELDS` constants, no
 * interface). The mapped keywords are the queryable dimensions of `UserModerationRecord`;
 * `auto_reject` is the confirmed-vs-auto axis. `screen_name` is deliberately NOT indexed
 * (resolved at query time from the profile surface). No analyzers (plain mappings), so
 * `settings.analysis` is OMITTED. `PK`/`SK` and any unmapped field stay stored via
 * `dynamic: true`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildModerationUsersTemplate = buildModerationUsersTemplate;
/** Build the composable OpenSearch index-template body for the `moderation-users` family. */
function buildModerationUsersTemplate(opts) {
    return {
        index_patterns: [opts.pattern],
        template: {
            settings: {
                number_of_shards: opts.shards ?? 1,
                number_of_replicas: opts.replicas ?? 0,
                refresh_interval: opts.refresh ?? '5s',
            },
            mappings: {
                dynamic: true,
                properties: {
                    identity_id: { type: 'keyword' },
                    incident_type: { type: 'keyword' },
                    severity: { type: 'keyword' },
                    content_type: { type: 'keyword' },
                    content_id: { type: 'keyword' },
                    moderation_id: { type: 'keyword' },
                    moderator_id: { type: 'keyword' },
                    auto_reject: { type: 'boolean' },
                    created_at: { type: 'date' },
                },
            },
        },
        priority: 100,
        _meta: { managed_by: 'fpw', purpose: 'moderation-users' },
    };
}
